export default __webpack_public_path__ + "static/media/integration.3a6bf79b.svg";